(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fs-welcome"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fs-welcome')) {
    customElements.define('fs-welcome', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.dialog = this.querySelector('dialog');
        this.trigger = this.querySelector('[data-welcome-open]');
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
        this.trigger.hidden = false;
        this.trigger.addEventListener('click', () => this.open(), options);
        this.querySelector('[data-welcome-close]').addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('close', () => {
          clearTimeout(this.timer);
          this.remember();
          this.previousFocus?.focus({ preventScroll: true });
        }, options);
        // Cualquier enlace a #bienvenida (p. ej. la barra de anuncios) abre el formulario
        document.addEventListener('click', (event) => {
          const link = event.target.closest?.('a[href$="#bienvenida"]');
          if (!link) return;
          event.preventDefault();
          this.open();
        }, { ...options, capture: true });
        const result = this.querySelector('[data-welcome-result]');
        if (result) {
          this.open();
          if (result.dataset.welcomeResult === 'success') this.remember();
          return;
        }
        if (location.hash === '#bienvenida') {
          this.open();
          return;
        }
        if (this.dataset.auto !== 'true' || !['index', 'product', 'collection'].includes(this.dataset.page) || this.dismissed()) return;
        this.timer = setTimeout(() => this.tryOpen(), Number(this.dataset.delay || 45) * 1000);
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.controller?.abort();
      }
      dismissed() {
        try { return Date.now() < Number(localStorage.getItem('fs-welcome-until') || 0); }
        catch { return true; }
      }
      remember() {
        try { localStorage.setItem('fs-welcome-until', String(Date.now() + 7 * 86400000)); } catch {}
      }
      blocked() {
        if (document.hidden) return true;
        const overlays = document.querySelectorAll('#shopify-pc__banner, dialog[open], [role="dialog"][aria-modal="true"]');
        return [...overlays].some(node => node !== this.dialog && node.getClientRects().length && getComputedStyle(node).visibility !== 'hidden');
      }
      open() {
        if (this.dialog.open) return;
        clearTimeout(this.timer);
        this.previousFocus = document.activeElement;
        this.dialog.showModal();
      }
      tryOpen() {
        if (!this.isConnected || this.dismissed()) return;
        const typing = document.activeElement?.matches('input,textarea,select,[contenteditable="true"]');
        if (this.blocked() || typing) {
          // Espera a que se cierre el aviso de cookies u otra ventana y deja unos segundos de margen
          this.waited = true;
          this.timer = setTimeout(() => this.tryOpen(), 2000);
          return;
        }
        if (this.waited) {
          this.waited = false;
          this.timer = setTimeout(() => this.tryOpen(), 8000);
          return;
        }
        this.open();
        this.remember();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
